import React from "react";
import { Link } from "react-router-dom";

const Walletsection1 = () => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title">
          <div className="row align-items-center justify-content-between">
            <div className="col-xl-4">
              <div className="page-title-content">
                <h3>Wallets</h3>
                <p className="mb-2">Welcome P2P Finance Management</p>
              </div>
            </div>
            <div className="col-auto">
              <div className="breadcrumbs">
                <Link to="#">Home </Link>
                <span>
                  <i className="fi fi-rr-angle-small-right" />
                </span>
                <Link to="#">Wallets</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Walletsection1;
